import { AdminSearchApplications } from "../components/AdminSearchApplications";
export function AdminEditReg() {

    document.title = `Търсене - Редакция`;

    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Редакция на заявление</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Редакция на заявление</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        <div className="row">
                            <AdminSearchApplications action='edit'/>
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminEditReg;